import React from 'react';
import { OnboardingStepProps } from '../types';
import { useScanProgress } from '../hooks/useScanProgress';

export const ScanProgress: React.FC<OnboardingStepProps> = ({ onNext }) => {
  const { progress, currentTask, discoveredAssets } = useScanProgress({ onComplete: onNext });

  return (
    <div className="space-y-6">
      {/* Progress Bar */}
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-400">{currentTask}</span>
          <span className="text-white">{Math.round(progress)}%</span>
        </div>
        <div className="h-2 bg-gray-800 rounded-full overflow-hidden">
          <div
            className="h-full bg-blue-500 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      {/* Discovery Stats */}
      <div className="grid grid-cols-2 gap-4">
        <div className="p-4 bg-gray-800/30 rounded-lg">
          <div className="text-sm text-gray-400">Domains</div>
          <div className="text-2xl font-bold text-white">{discoveredAssets.domains}</div>
        </div>
        <div className="p-4 bg-gray-800/30 rounded-lg">
          <div className="text-sm text-gray-400">Subdomains</div>
          <div className="text-2xl font-bold text-white">{discoveredAssets.subdomains}</div>
        </div>
        <div className="p-4 bg-gray-800/30 rounded-lg">
          <div className="text-sm text-gray-400">IP Addresses</div>
          <div className="text-2xl font-bold text-white">{discoveredAssets.ips}</div>
        </div>
        <div className="p-4 bg-gray-800/30 rounded-lg">
          <div className="text-sm text-gray-400">Vulnerabilities</div>
          <div className="text-2xl font-bold text-white">{discoveredAssets.vulnerabilities}</div>
        </div>
      </div>

      <div className="text-sm text-gray-400">
        This initial scan may take several minutes to complete. We'll notify you once it's done.
      </div>
    </div>
  );
};